/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListColumnPresetsQueryResponse,
  ListColumnPresetsQueryParams,
} from '../../types/ListColumnPresets'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listColumnPresets } from '../../clients/listColumnPresets'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listColumnPresetsQueryKey = (
  params?: ListColumnPresetsQueryParams
) => [{ url: '/api/v1/column-presets/' }, ...(params ? [params] : [])] as const

export type ListColumnPresetsQueryKey = ReturnType<
  typeof listColumnPresetsQueryKey
>

export function listColumnPresetsQueryOptions(
  params?: ListColumnPresetsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listColumnPresetsQueryKey(params)
  return queryOptions<
    ListColumnPresetsQueryResponse,
    ResponseErrorConfig<Error>,
    ListColumnPresetsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listColumnPresets(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary List column presets visible to the current user
 * {@link /api/v1/column-presets/}
 */
export function useListColumnPresets<
  TData = ListColumnPresetsQueryResponse,
  TQueryData = ListColumnPresetsQueryResponse,
  TQueryKey extends QueryKey = ListColumnPresetsQueryKey,
>(
  params?: ListColumnPresetsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListColumnPresetsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? listColumnPresetsQueryKey(params)

  const query = useQuery(
    {
      ...listColumnPresetsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
